import React, { useState, useCallback, useEffect } from "react";
import {
  Button,
  FormFieldSet,
  InfoCardTwo,
  StatusTags,
  useFormHandler,
  DropdownMenu,
  LogoLoader,
  Backdrop,
  showToast,
  TableAdv,
  InfoCardNewAdv,
  InfoWrapper,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { useNavigate } from "react-router-dom";
import {
  createDuplicateCampaignApi,
  fetchInstantlyBulkAnalyst,
  fetchTemplateById,
  pauseInstantlyCampaignApi,
  startInstantlyCampaignApi,
} from "../../../../redux/slices/compaigns/compaignsApi";
import { useDispatch, useSelector } from "react-redux";
import {
  getFollowAssignDataStart,
  getInstantlyAccessId,
  getInstantlyCampaign,
  sendBulkEmailsStart,
  successInstantlyCampaign,
} from "../../../../redux/slices/compaigns/compaignsSlice";
import dayjs from "dayjs";
import { useLoginUser } from "../../../../hooks/useLoginUser";
const BulkEmails = () => {
  const { userData: loginUserData } = useLoginUser();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sendMailList, setSendMailList] = useState(["omkar@tektreeinc.com"]);
  const [manualSendMailList, setManualSendMailList] = useState([]);
  
  const campaigns = useSelector(
    (state) => state.compaigns?.instantly?.campaigns
  );
  const campaignsAccessId = useSelector(
    (state) => state.compaigns?.instantly?.accessId
  );
    const followData = useSelector(
      (state) => state.compaigns.assignData.followData
    );
  const allCampaignsList = campaigns?.data || [];
  const handleSendMailListChange = useCallback((emailList) => {
    setSendMailList(emailList);
  }, []);
  const STATUS_MAP = {
    0: "Draft",
    1: "Active",
    2: "Paused",
    3: "Completed",
    4: "Running Subsequences",
    "-99": "Account Suspended",
    "-1": "Accounts Unhealthy",
    "-2": "Bounce Protect",
  };

  const handleInstantlyApiCalls = async ({ action, payload }) => {
    try {
      if (!action || !payload) {
        showToast("Missing required parameters", "error");
        return;
      }

      let response;
      let successMessage = "";

      switch (action) {
        case "pause": {
          response = await pauseInstantlyCampaignApi({ payload,accessId: campaignsAccessId });
          successMessage = response?.success
            ? "Campaign paused successfully"
            : "Failed to pause campaign";
          break;
        }
        case "start": {
          response = await startInstantlyCampaignApi({ payload,accessId: campaignsAccessId });
          successMessage = response?.success
            ? "Campaign started successfully"
            : "Failed to start campaign";
          break;
        }
        case "duplicate":{
          response = await createDuplicateCampaignApi({payload,accessId: campaignsAccessId});
           successMessage = response?.success
            ? "Campaign duplicate  created successfully"
            : "Failed to duplicate campaign";
          break;
        }
        case "getCampaign" :{
          // getInstantlyCampaign
          response= await getInstantlyCampaign({payload,accessId:campaignsAccessId}) 
          break;
        }
      }
      showToast(successMessage, response?.success ? "success" : "error");
      handleCallApi();
    } catch (error) {
      showToast("Something went wrong. Please try again.", "error");
    }
  };
// const handleGetCampaign
  const columns = [
    {
      key: "name",
      label: "Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => {
        return <div className="cursor-pointer"
          onClick={()=> {
            handleInstantlyApiCalls({action:"getCampaign",payload:{campaignId: row?.id}}) 
            navigate(`/ats/campaigns/add-campaign`, { state: { isEdit: true, campaignId: row?.id } })     
          }}
        >{row?.name}</div>
      }
    },
    {
      key: "status",
      label: "Status",
      render: (row) => {
        const statusText = STATUS_MAP[row.status] || "Unknown";
        return <StatusTags tag={statusText} />;
      },
    },
    {
      key: "progress",
      label: "Progress",
    },
    {
      key: "sent",
      label: "Sent",
      render: (row) => {
        return <div>{row?.analytics?.emails_sent_count}</div>;
      },
    },
    {
      key: "click",
      label: "Click",
    },
    {
      key: "replied",
      label: "Replied",
      render: (row) => {
        return <div>{row?.analytics?.reply_count}</div>;
      },
    },
    {
      key: "oppurtunities",
      label: "Oppurtunities",
      render: (row) => {
        return <div>{row?.analytics?.total_opportunities}</div>;
      },
    },
    {
      key: "action",
      label: "Action",
      render: (row) => (
        <DropdownMenu
          MenuSection={
            <div className="flex flex-col">
              <Button
                title={"Pause"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-2"
                onClick={() =>
                  handleInstantlyApiCalls({
                    action: "pause",
                    payload: { campaignId: row?.id,accessId:campaignsAccessId, },
                  })
                }
              />
              <Button
                title={"Start"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-2"
                onClick={() =>
                  handleInstantlyApiCalls({
                    action: "start",
                    payload: { campaignId: row?.id,accessId:campaignsAccessId },
                  })
                }
              />
              <Button
                title={"Campaign Name"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-2"
              />
              <Button
                title={"Delete Campaign"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-2"

              />
              <Button
                title={"Duplicate Campaign"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-2"
                onClick={() =>
                  handleInstantlyApiCalls({
                    action: "duplicate",
                    payload: { campaignId: row?.id,accessId:campaignsAccessId, name: `${row?.name} duplicate` },
                  })
                }
              />
              <Button
                title={"Downloade Campaign"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-2"
              />
              <Button
                title={"Share Campaign"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-2"
              />
            </div>
          }
        >
          <Button
            icon={"more_vert"}
            variant="text"
            type="icon"
            size="sm"
            color="black"
          />
        </DropdownMenu>
      ),
    },
  ];
  const initialData = {
    typeSource: "",
    allStatus: "",
    sort: "",
    emailSource: "",
    emailAccount: "",
    typeOfEmail: "",
    date: "",
    template: "",
    subject: "",
    emailText: "",
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialData, {
      emailSource: { type: "select", required: true, },
      typeSource: { type: "select", required: true,  },
      emailAccount: { type: "select", required: true,  },
      typeOfEmail: { type: "select", required: true,  },
      date: { type: "date", required: true,  },
      template: { type: "select", required: true,  },
    });

  const mappedRows = mapTableRows(allCampaignsList, columns);
  const handleGetTemplate = async (templateId) => {
    try {
      // Assuming you have an API function to fetch template details by ID
      const response = await fetchTemplateById({
        coll: "Template",
        fil: { uiid: templateId },
        ret: "body subject uiid",
      });
      if (response && response.data) {
        setFormData((prevData) => ({
          ...prevData,
          emailText: response.data.body || "",
          subject: response.data.subject || "",
        }));
      }
    } catch (error) {}
  };
  const handleCallBulkAnalyst = async ({ items, nextpage }) => {
    const campaignIds = items.map((c) => c.id);
    const getAnalyticsResponse = await fetchInstantlyBulkAnalyst({
      ids: campaignIds,
      accessId:campaignsAccessId
    });
    const analyticsMap = {};
    (getAnalyticsResponse?.data?.data?.analytics || []).forEach((analytics) => {
      analyticsMap[analytics.campaign_id] = analytics;
    });
    const mergedData = items.map((item) => ({
      ...item,
      analytics: analyticsMap[item.id] || {},
    }));
    dispatch(
      successInstantlyCampaign({
        data: mergedData,
        nextpage: nextpage,
      })
    );
  };
  const handleCallApi = async (search = "") => {
    const payload = {
      lim: 20,
      search: search,
      ret: "id name status timestamp_created timestamp_updated pl_value email_list daily_limit stop_on_reply organization email_tag_list",
      accessId:campaignsAccessId
    };
    setLoading(true);
    dispatch(
      getInstantlyCampaign({
        payload,
        onSuccess: (data) => {
          setLoading(false);
          if(data){
          handleCallBulkAnalyst({
            items: data?.items,
            nextpage: data?.nextpage,
          });
        }
        setLoading(false);
        },
      })
    );
  };
  const fetchFollowAssignments = (date) => {
    const filterDate = dayjs(date).format("YYYY-MM-DD");
    const filter = { date: { type: "NONE", value: filterDate } };
    dispatch(
      getFollowAssignDataStart({
        coll: "Shuffle",
        lim: 1,
        pg: 1,
        ref: "Jobwithcompany Propects",
        extret: "uiid firstName email lastName level",
        fil: JSON.stringify(filter),
        sort: JSON.stringify({ uiid: -1 }),
        extincl: JSON.stringify(["uiid"]),
      })
    );
  };
const filteredEmailCount = React.useMemo(() => {
  if (!Array.isArray(followData[0]?.shuffle) || !formData?.emailAccount?.label) {
    return 0;
  }
  const matchedItem = followData[0].shuffle.find(
    (item) =>
      item?.BdmId?.uiid ===22
  );
   const validProspects = matchedItem.assignedProspectData.filter(
    (prospect) =>
      prospect?.prospectId !== null &&
      prospect?.prospectId !== "" &&
      prospect?.prospectId !== undefined
  );
  return validProspects.length;
}, [followData, formData.emailAccount]);


const handleSendEmails = () => {
  const validate = validateAllFields();
  if (!validate) {
    showToast("Please select all fields","error",2000);
    return;
  }
  // 1. Get matched items safely
  const matchedItems = followData?.[0]?.shuffle?.filter(
    (item) => item?.BdmId?.uiid === 22
  ) || [];
  // 2. Merge all valid prospects from each matched item
  const validProspects = matchedItems
    .flatMap(item => item?.assignedProspectData || [])
    .filter(
      (prospect) =>
        prospect?.prospectId !== null &&
        prospect?.prospectId !== "" &&
        prospect?.prospectId !== undefined
    );
  // 3. Build internal email payloads
  const internal = validProspects.map((prospect) => ({
    type: 1,
    addedBy: loginUserData?.uiid,
    prospectId: prospect?.prospectId?.uiid,
    lastHistoryStatus: 1,
    historyLogs: {
      bdmId: formData?.emailAccount?.userId,
      from: formData?.emailAccount?.label,
      integrationAccessId: formData?.emailAccount?.accessUiid,
      jobId: prospect?.jobId?.uiid || null,
      shuffleId: followData?.[0]?.uiid,
      templateId: formData?.template?.value,
      source: formData?.emailSource,
      typeOfEmail: formData?.typeOfEmail,
      addedBy: loginUserData?.uiid,
    }
  }));
  // 4. Build manual email payloads
  const manual = (manualSendMailList || []).map((email) => ({
    type: 2,
    addedBy: loginUserData?.uiid,
    email: email,
    lastHistoryStatus: 1,
    historyLogs: {
      bdmId: formData?.emailAccount?.userId,
      from: formData?.emailAccount?.label,
      integrationAccessId: formData?.emailAccount?.accessUiid,
      jobId: null,
      shuffleId: followData?.[0]?.uiid,
      templateId: formData?.template?.value,
      source: formData?.emailSource,
      typeOfEmail: formData?.typeOfEmail,
      addedBy: loginUserData?.uiid,
    }
  }));
  const payload = { internal, manual };
  // 5. Validate internal emails before dispatching
  if (internal.length === 0) {
    showToast("Emails are not assigned");
    return;
  }
 dispatch(
  sendBulkEmailsStart({
    payload,
    onSuccess: () => {
      showToast("Emails are Processed");
    }
  })
);

};
useEffect(()=>{
  const fetchIntantlyAccessIs=async()=>{
    if(!campaignsAccessId){
    dispatch(getInstantlyAccessId({fil:{category:{type:"NONE",value:11},type:{type:"NONE",value:5},status:{type:"NONE",value:1}},coll:"Integration"}))
    }
  }
  fetchIntantlyAccessIs()
},[])
  return (
    <div>
      <InfoWrapper className="min-w-60! max-w-100! mt-5!">
        <InfoCardNewAdv title="Count of emails" value={filteredEmailCount} layout="option8" icon="work"/>
        {/* <InfoCardTwo title="Open Jobs" value={18} /> */}
      </InfoWrapper>
      <div className="p-4">
        <FormFieldSet
          type="radio"
          noTitle
          value={formData.typeSource}
          options={[
            { label: "Instantly", value: "instantly" },
            { label: "Other Email Sources", value: "other" },
          ]}
          onChange={(e) => {
            handleChange("typeSource", e.target.value);
            if (e.target.value === "instantly") {
              handleCallApi();
            }
          }}
          error={errors.typeSource}
        />
      </div>
      {formData.typeSource === "instantly" && (
        <div>
          <TableAdv
            showCheckbox
            rows={mappedRows}
            columns={columns}
            serverOnSearch={(key, val) => handleCallApi(val)}
            toolbarRight={{
              search: true,
              add: [
                {
                  component: (
                    <div className="flex items-center gap-1">
                      <div className="w-35">
                        <FormFieldSet
                          type="select"
                          noTitle
                          size="sm"
                          placeholder="All Status"
                          options={[
                            { label: "Ascending", value: "ascending" },
                            { label: "Descending", value: "descending" },
                            { label: "A to Z", value: "atoz" },
                            { label: "Z to A", value: "ztoa" },
                          ]}
                          value={formData.allStatus}
                          onChange={(value) => handleChange("allStatus", value)}
                          error={errors.allStatus}
                        />
                      </div>
                      <div className="w-35">
                        <FormFieldSet
                          type="select"
                          noTitle
                          size="sm"
                          placeholder="Sort"
                          value={formData.sort}
                          onChange={(e) => handleChange("sort", e.target.value)}
                          error={errors.sort}
                          options={[
                            { label: "Ascending", value: "ascending" },
                            { label: "Descending", value: "descending" },
                            { label: "A to Z", value: "atoz" },
                            { label: "Z to A", value: "ztoa" },
                          ]}
                        />
                      </div>
                      <Button
                        icon={"add"}
                        size="sm"
                        title={"Add Campaign"}
                        onClick={() => navigate("/ats/campaigns/add-campaign")}
                      />
                    </div>
                  ),
                },
              ],
            }}
          />
        </div>
      )}
      {formData.typeSource === "other" && (
        <div className="px-4 py-2">
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 ">
            <FormFieldSet
              type="select"
              placeholder="Select"
              title="Email Source"
              options={[
                { label: "Gmail", value: 1 },
                { label: "Outlook", value: 2 },
                { label: "Mailgun", value: 3 },
                { label: "AWS-SES", value: 4 },
              ]}
              value={formData.emailSource}
              onChange={(value) => handleChange("emailSource", value)}
              error={errors.emailSource}
              shadow={true}
            />
            <FormFieldSet
              type="emailSourceAccounts"
              placeholder="Select Account"
              title="Email Account"
              // options={[
              //   { label: "brown@tektreeinc.com", value: "1" },
              //   { label: "aden@tektreeinc.com", value: "2" },
              // ]}
              value={formData.emailAccount}
              onChange={(value) => handleChange("emailAccount", value)}
              error={errors.jobCode}
              disabled={!formData.emailSource}
              filters={{ category: 11, type: formData.emailSource }}
              // filters={{ employeeId: employeeProfileUiid }}
              shadow={true}
            />
            <FormFieldSet
              type="select"
              placeholder="Select Email"
              title="Type of Email"
              options={[
                { label: "Latest Data", value: 1 },
                { label: "Follow-up Data", value: 2 },
              ]}
              value={formData.typeOfEmail}
              onChange={(value) => {
                handleChange("typeOfEmail", value);
                const selectedDate =value === 1 ? dayjs() : dayjs().subtract(1, "day");
                handleChange("date", selectedDate);
                fetchFollowAssignments(selectedDate)
              }}
              error={errors.typeOfEmail}
              shadow={true}
            />
            <FormFieldSet
              type="datepicker"
              placeholder="Select Account"
              title="Date Picker"
              value={formData.date}
              onChange={(value) => {
                handleChange("date", value)
                fetchFollowAssignments(value)
              }}
              error={errors.date}
              shadow={true}
            />
            <FormFieldSet
              type="templates"
              placeholder="Select"
              title="Template"
              options={[
                { label: "Brown", value: "1" },
                { label: "Aden", value: "2" },
              ]}
              value={formData.template}
              onChange={(value) => {
                handleChange("template", value);
                handleGetTemplate(value?.value);
              }}
              error={errors.template}
              disabled={!formData.emailAccount}
              // filters={{ userId: formData.emailAccount?.userId }}
              filters={{ userId: 3 }}
              shadow={true}
            />
            <FormFieldSet
              placeholder="Subject"
              title="Subject"
              value={formData.subject}
              onChange={(value) => handleChange("subject", value)}
              error={errors.subject}
              shadow={true}
            />
          </div>
          <div className="grid grid-cols-1 my-4 gap-6">
            <FormFieldSet
              // value={["simon@tektreeinc.com", "john.doe@tektreeinc.com"]}
              value={manualSendMailList}
              maxCount={50}
              type="toMailIds"
              title="Include Test Emails Here"
              placeholder="Type or paste email addresses and press enter"
              onChange={setManualSendMailList}
              error={errors.toMailIds}
              info="You can add up to 50 email addresses. These emails will receive the test email."
              shadow={true}
            />
            <FormFieldSet
              type="textArea"
              title="Text Here"
              value={formData.emailText}
              onChange={(value) => handleChange("emailText", value)}
              error={errors.emailText}
              rows={4}
              shadow={true}
            />
          </div>
          <div className="flex justify-end" >
            <Button  title={"Save"}  onClick={()=>handleSendEmails()}/>
          </div>
        </div>
      )}
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default BulkEmails;
